import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import Select from 'react-select';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import * as CatalogPageActionCreators from '../../redux/catalogPages';
import ImageUploader from 'react-images-upload';
import * as EventsActionCreators from '../../redux/events';
import {
  List,
  ListItem,
  ListItemText,
  IconButton,
  ListItemSecondaryAction
} from '@material-ui/core';
import RootRef from '@material-ui/core/RootRef';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DeleteIcon from '@material-ui/icons/Delete';

const { REACT_APP_FRONTEND_URL } = process.env;

const ImageWrraper = styled.div`
  background-color: ${props => props.primary_color};
  padding: 5%;
  > img {
    width: 100%;
  }
`;
// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
  // styles we need to apply on draggables
  ...draggableStyle,
  background: '#eeeeee',
  marginBottom: '4px',
  ...(isDragging && {
    background: 'rgb(235,235,235)'
  })
});

const getListStyle = isDraggingOver => ({
  // background: isDraggingOver ? 'lightblue' : 'lightgrey',
});
class CatalogEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      bannerImage: '',
      primary_color: '',
      URL: '',
      number_of_events: '',
      pictures: [],
      event: '',
      iceredIdAvailable: undefined,
      entities: [],
      removeEntities: []
    };
    this.onDrop = this.onDrop.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const entities = reorder(
      this.state.entities,
      result.source.index,
      result.destination.index
    );

    this.setState({
      entities
    });
  }

  deleteIndex = index => {
    const { entities } = this.state;
    const { removeEntities } = this.state;
    const { catalog_page } = this.props;
    if (catalog_page) {
      for (var i = 0; i < catalog_page.entities.length; i++) {
        if (catalog_page.entities[i].id === entities[index].id) {
          removeEntities.push(entities[index]);
        }
      }
    }

    entities.splice(index, 1);
    this.setState({
      entities
    });
  };

  change = v => {
    this.setState({
      entities: v.target.value
    });
  };

  onDrop(pictureFiles, pictureDataURLs) {
    this.setState({
      pictures: pictureFiles
    });
  }
  async saveImage(catalogId, file, type) {
    const { actions } = this.props;

    const formData = new FormData();
    formData.append('image', file);
    formData.append('type', type);

    try {
      await actions.uploadCatalogPageImage(catalogId, formData);
    } catch (e) {
      throw e;
    }
  }

  async componentDidMount() {
    const {
      actions,
      match: { params }
    } = this.props;
    if (params.id) {
      await actions.getCatalogPage(params.id);
      let { catalog_page } = this.props;
      this.setState({
        name: catalog_page.name,
        bannerImage: catalog_page.image_url,
        primary_color: catalog_page.primary_color,
        URL: catalog_page.url,
        entities: [...catalog_page.entities]
      });
    }
    actions.getEventsList();
  }

  async uploadCatalog() {
    const { actions, catalog_page, history } = this.props;
    const { removeEntities } = this.state;
    if (
      this.state.name &&
      this.state.primary_color &&
      this.state.URL &&
      this.state.iceredIdAvailable !== false
    ) {
      if (catalog_page.id) {
        await actions.updateCatalogPage(catalog_page.id, {
          name: this.state.name,
          primary_color: this.state.primary_color,
          url: this.state.URL
        });
        if (this.state.pictures.length) {
          await this.saveImage(
            catalog_page.id,
            this.state.pictures[0],
            'cover'
          );
        }
        const promises = [];
        if (removeEntities.length) {
          for (let i = 0; i < removeEntities.length; i++) {
            promises.push(actions.removeCatalogEntity(removeEntities[i].id));
          }
        }
        for (let i = 0; i < this.state.entities.length; i++) {
          if (!this.state.entities[i].entity_type) {
            promises.push(
              actions.createCatalogPageEntities({
                entity_type: 'event',
                entity_id: this.state.entities[i].entity_id,
                catalog_id: catalog_page.id,
                order: i
              })
            );
          } else if (this.state.entities[i].order !== i) {
            promises.push(
              actions.updateCatalogEntityPage(this.state.entities[i].id, {
                entity_type: 'event',
                entity_id: this.state.entities[i].entity_id,
                catalog_id: catalog_page.id,
                order: i
              })
            );
          }
        }
        await Promise.all(promises);
      } else {
        const cateLogPageAdded = await actions.createCatalogPage({
          name: this.state.name,
          primary_color: this.state.primary_color,
          url: this.state.URL
        });
        if (this.state.pictures.length) {
          await this.saveImage(
            cateLogPageAdded.id,
            this.state.pictures[0],
            'cover'
          );
        }
        const promises = [];
        for (let i = 0; i < this.state.entities.length; i++) {
          promises.push(
            actions.createCatalogPageEntities({
              entity_type: 'event',
              entity_id: this.state.entities[i].entity_id,
              catalog_id: cateLogPageAdded.id,
              order: i
            })
          );
        }
        await Promise.all(promises);
      }
      history.push('/catalog-pages');
    }
  }

  onChangeInput(field, value) {
    if (field === 'URL') {
      value = value
        .replace(/ /g, '-')
        .replace(/[\u1000-\uFFFF]+/g, '')
        .replace(/[^a-zA-Z0-9-]/g, '');
      this.checkAndSetIdError(value);
    }
    this.setState({ [field]: value });
  }

  handleChange = name => value => {
    this.setState({
      [name]: ''
    });
    const eventAlreadyInList = this.state.entities.filter(
      entitie => entitie.entity_id === value.entity_id
    );
    if (eventAlreadyInList.length > 0) {
      alert('this event is already in this catalog list');
    } else {
      this.state.entities.push(value);
      this.setState({
        entities: this.state.entities
      });
    }
  };

  checkAndSetIdError(value) {
    this.checkIceredId(value, isAvailable => {
      if (isAvailable) {
        this.setState({ iceredIdAvailable: true });
      } else {
        this.setState({ iceredIdAvailable: false });
      }
    });
  }

  checkIceredId(id, cb) {
    const { actions } = this.props;

    clearTimeout(this.iceredIdTimer);
    this.iceredIdTimer = setTimeout(() => {
      actions
        .checkIceredId(id)
        .then(cb)
        .catch(console.error);
    }, 300);
  }

  render() {
    const { name, primary_color, URL, bannerImage } = this.state;
    const { events, catalog_page } = this.props;
    events &&
      events.length &&
      events.forEach(element => {
        element.entity_id = element.real_id;
        element.label = element.name;
        element.value = element.id;
      });
    const eventURL = `${REACT_APP_FRONTEND_URL}/${URL}`;
    return (
      <div>
        <div>
          <div>
            <TextField
              value={name}
              id="name"
              label="Name *"
              type="text"
              margin="normal"
              onChange={e => this.onChangeInput('name', e.target.value)}
            />
          </div>
          <div>
            {!catalog_page.id ? (
              <TextField
                value={URL}
                id="url"
                label="URL *"
                type="text"
                margin="normal"
                onChange={e => this.onChangeInput('URL', e.target.value)}
              />
            ) : (
              <div>
                <p>
                  <a href={eventURL} target="_blank">
                    {eventURL}
                  </a>
                </p>
              </div>
            )}
            {this.state.iceredIdAvailable === false ? (
              <p> ID is not Available</p>
            ) : null}
          </div>
          <div>
            {events && events.length ? (
              <Select
                options={events}
                value={this.state.event}
                onChange={this.handleChange('number_of_events')}
                placeholder="Add an event"
              />
            ) : null}
            <DragDropContext onDragEnd={this.onDragEnd.bind(this)}>
              <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                  <RootRef rootRef={provided.innerRef}>
                    <List style={getListStyle(snapshot.isDraggingOver)}>
                      {this.state.entities.map((item, index) => (
                        <Draggable
                          key={item.id}
                          draggableId={item.id}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <RootRef rootRef={provided.innerRef}>
                              <ListItem
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={getItemStyle(
                                  snapshot.isDragging,
                                  provided.draggableProps.style
                                )}
                              >
                                <ListItemText primary={item.name} />
                                <ListItemSecondaryAction
                                  onClick={this.deleteIndex.bind(this, index)}
                                >
                                  <IconButton>
                                    <DeleteIcon />
                                  </IconButton>
                                </ListItemSecondaryAction>
                              </ListItem>
                            </RootRef>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </List>
                  </RootRef>
                )}
              </Droppable>
            </DragDropContext>
          </div>
          <div>
            <TextField
              value={primary_color}
              id="bgcolor2"
              type="text"
              label="Background Color *"
              margin="normal"
              onChange={e =>
                this.onChangeInput('primary_color', e.target.value)
              }
            />
            <TextField
              value={primary_color}
              id="bgcolor1"
              type="color"
              margin="normal"
              onChange={e =>
                this.onChangeInput('primary_color', e.target.value)
              }
            />
            <span> use Safari for better color detection</span>
          </div>
          {bannerImage && (
            <ImageWrraper primary_color={primary_color}>
              <img alt="" src={bannerImage} />
            </ImageWrraper>
          )}
          <ImageUploader
            withIcon={true}
            buttonText="Choose images"
            onChange={this.onDrop}
            imgExtension={['.jpg', '.gif', '.png', '.gif']}
            maxFileSize={5242880}
            withPreview={true}
          />

          <div style={{ marginTop: '10px' }}>
            <Button
              onClick={() => this.uploadCatalog()}
              variant="raised"
              component="span"
            >
              Save Catelog Page
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    events: state.events.events,
    catalog_page: state.catalog_pages.catalog_page
  };
};
const ActionCreators = Object.assign(
  {},
  CatalogPageActionCreators,
  EventsActionCreators
);
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(ActionCreators, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CatalogEditPage)
);



// WEBPACK FOOTER //
// ./src/pages/catalog-pages/edit.js